import "../css/style.scss"

const $ = jQuery;

window.onload = function() {
    init_openMenu();
    initScrollEffects();
    initHoverEffects();
    initReveal();
    initOpenform();
    // initAddtoCart();
  };

// ############functie voor uitklapmenu########
function init_openMenu(){
    $('#button_nav').click(function(){
        $('#button_nav').toggleClass('open-menu');
        $('#menu_nav').toggleClass('open-menu');
    });
}
function initScrollEffects(){
    window.onscroll = function(){
        let scrollToTop = document.getElementById("scrollToTop");
        function btnScrollToTopScrollDown(){
            $(scrollToTop).animate({
                bottom: '20px'
            },
            {
                queue: false,
                duration: 300
            });
        }
        function btnScrollToTopScrollUp(){
            $(scrollToTop).animate({
                bottom: '-200px'
            },
            {
                queue: false,
                duration: 300
            });
        }
        if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) {
            btnScrollToTopScrollDown();          
        }else{
            btnScrollToTopScrollUp();
        }
    }
}
function initHoverEffects(){
    $(".card-hover").mouseenter(function(){
        $(this).animate({
            bottom: '10px',
        },
        {
            queue: false,
            duration: 300
        });
    });
    $(".card-hover").mouseleave(function(){
        $(this).animate({
            bottom: 0,
        },
        {
            queue: false,
            duration: 300
        });
    });
}
function initLightSlider(){
    $("#lightSlider").lightSlider({
        item:3,
        loop:true,
        auto: true,
        pauseOnHover: true,
        slideMove:1,
        easing: 'cubic-bezier(0.25, 0, 0.25, 1)',
        speed: 1500,
        pause: 10000,
        responsive : [
            {
                breakpoint:992,
                settings: {
                    item:2,
                    slideMove:1,
                    slideMargin:6,
                  }
            },
            {
                breakpoint:540,
                settings: {
                    item:1,
                    slideMove:1
                  }
            }
        ]
    });
}
function initReveal(){
    function reveal() {
        var reveals = document.querySelectorAll(".reveal");
      
        for (var i = 0; i < reveals.length; i++) {
          var windowHeight = window.innerHeight;
          var elementTop = reveals[i].getBoundingClientRect().top;
          var elementVisible = 150;
      
          if (elementTop < windowHeight - elementVisible) {
            reveals[i].classList.add("active");
          } else {
            reveals[i].classList.remove("active");
          }
        }
      }
      
      window.addEventListener("scroll", reveal);
}

function initAddtoCart(){
        $('body').on('submit', '.products .cart', function(e) {
          e.preventDefault();
      
          var form = $(this);
          var button = form.find('.single_add_to_cart_button');
          var originalButtonText = button.text();
          var quantity = form.find('.quantity .qty').val();
          var product_id = form.find('[name=add-to-cart]').val();
      
          button.text('Adding...').prop('disabled', true);
      
          var data = {
            action: 'woocommerce_add_to_cart',
            quantity: quantity,
            product_id: product_id
          };
      
          $.post(wc_add_to_cart_params.ajax_url, data, function(response) {
            if (response.error) {
              console.error(response.error);
            } else {
              $(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash]);
            }
      
            button.text(originalButtonText).prop('disabled', false);
          }, 'json');
        });
      
}
function initOpenform(){
    $('#title_form').click(function(){
        $('#lostpasswordform').toggleClass('open-form');
    })
}






